module.exports = __webpack_public_path__ + "assets/img/init_pos_floor1.571dc5f3.png";